import { Box, BoxProps } from "@chakra-ui/react";
import { FiMapPin } from "react-icons/fi";

export const MapPinIcon = (props: BoxProps) => {
  return <Box as={FiMapPin} height="20px" width="20px" {...props} />;
};
